<template>
    <div>
        <app-auction-navigation></app-auction-navigation>
        <div class="container">
            <div class="has-text-centered" v-if="!getIdParam">
                <p class="is-size-3">Please select car brand</p>
            </div>

            <div v-if="getIdParam">
                <app-search />
                <app-loader :loading="getLoaderStatus" :color="options.color" :size="options.size"></app-loader>
                <div class="columns is-multiline is-mobile is-centered is-hidden-touch" v-if="!getLoaderStatus">
                    <app-brand-type
                        v-for="(type, index) in getModelTypes"
                        :type="type"
                        :index="index"
                        :key="index"
                        :is-active="index === getActiveTypeIndex" />
                </div>
                <div class="columns is-mobile is-centered is-multiline is-hidden-touch" v-if="!getLoaderStatus">
                    <app-model-image v-for="(model, index) in getModelsByType"
                                     :model="model"
                                     :key="index" />
                </div>
                <div class="columns is-mobile is-centered is-multiline is-hidden-desktop" v-if="!getLoaderStatus">
                    <app-model-image v-for="(model, index) in getModels"
                                     :model="model"
                                     :key="index" />
                </div>
                <app-submit-button v-if="!getLoaderStatus" />
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from 'vue-spinner/src/ClipLoader'
    import Type from './AuctionBrandType'
    import ModelImage from './AuctionModelImage'
    import SearchBox from './SearchBox'
    import SubmitButton from '../SubmitSearchButton'
    import AuctionNavigation from './../AuctionNavigation'
    export default {
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        components: {
            appLoader: Loader,
            appBrandType: Type,
            appModelImage: ModelImage,
            appSearch: SearchBox,
            appSubmitButton: SubmitButton,
            appAuctionNavigation: AuctionNavigation
        },
        mounted() {
            this.$store.dispatch('changeActiveElement', 0)
            if ( this.$route.params.id ) {
                this.$store.dispatch('fetchBrandModels', this.$route.params.id)
                this.$store.dispatch('changeQueryCompanyId', this.$route.params.id)
            }

        },
        computed: {
            getActiveTypeIndex() {
                return this.$store.getters.getActiveType
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            getModelTypes() {
                return this.$store.getters.getModelTypes
            },
            getModels() {
                return this.$store.getters.getModels
            },
            getModelsByType() {
                return this.$store.getters.getActiveModels
            },
            getIdParam() {
                return this.$route.params.id
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Model/AuctionModels.vue